import BannerNotification from '@atoms/BannerNotification/BannerNotification';
import { IBannerNotification } from '@models/IBannerNotification';
import BreakpointEnum from '@models/enums/BreakpointEnum';

interface Props {
  readonly notifications: IBannerNotification[];
  readonly desktopBreakpoint?: BreakpointEnum.Large | BreakpointEnum.XLarge;
  readonly isContentExpandable?: boolean;
  readonly showMoreLabel?: string;
  readonly showLessLabel?: string;
  readonly hasLargeNotifications?: boolean;
  readonly dataTestId?: string;
}

const BasketNotifications = ({
  notifications,
  desktopBreakpoint,
  isContentExpandable,
  showMoreLabel,
  showLessLabel,
  hasLargeNotifications,
  dataTestId,
}: Props) => (
  <div className="flex flex-col gap-y-5" data-testid={dataTestId}>
    {notifications.map(({ displayStyle, icon, text, link }) => (
      <BannerNotification
        displayStyle={displayStyle}
        iconName={icon}
        richText={text}
        link={link}
        key={`${displayStyle}-${icon}-${text}-${link?.url}-${link?.name}`}
        desktopBreakpoint={desktopBreakpoint}
        isContentExpandable={isContentExpandable}
        showMoreLabel={showMoreLabel}
        showLessLabel={showLessLabel}
        isLarge={hasLargeNotifications}
      />
    ))}
  </div>
);

export default BasketNotifications;
